import { usePersonalStats } from "../api/usePersonalStats";
import { MetricCard } from "./MetricCard";
import { CompletionTrend } from "./CompletionTrend";
import { Skeleton } from "@hub/ui/components/ui/skeleton";
import { CheckCircle, Clock, AlertTriangle, TrendingUp } from "lucide-react";

export function PersonalDashboard() {
  const { stats, loading } = usePersonalStats();

  if (loading) {
    return (
      <div className="p-8 max-w-4xl mx-auto space-y-6">
        <Skeleton className="h-8 w-48" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-24" />
          ))}
        </div>
        <Skeleton className="h-48" />
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="p-8 max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">My Stats</h1>
        <div className="flex items-center justify-center h-48 bg-gray-50 dark:bg-white/5 rounded-lg">
          <p className="text-sm text-gray-400">No data available — projection definitions need to be configured.</p>
        </div>
      </div>
    );
  }

  const handleTimeDisplay = stats.avgHandleTimeMinutes > 0
    ? `${Math.round(stats.avgHandleTimeMinutes)}m`
    : "—";

  return (
    <div className="p-8 max-w-4xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">My Stats</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <MetricCard label="Completed Today" value={stats.completedToday} icon={CheckCircle} />
        <MetricCard label="Last 7 Days" value={stats.completedThisWeek} icon={TrendingUp} />
        <MetricCard label="Avg Handle Time" value={handleTimeDisplay} icon={Clock} />
        <MetricCard
          label="Approaching SLA"
          value={stats.approachingSla}
          icon={AlertTriangle}
          health={stats.approachingSla === 0 ? "green" : stats.approachingSla <= 3 ? "yellow" : "red"}
        />
      </div>

      <div className="bg-white dark:bg-white/5 rounded-lg border border-gray-200 dark:border-white/10 p-4">
        <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">
          Completion Trend (7 days)
        </h3>
        <CompletionTrend data={stats.dailyTrend} />
      </div>
    </div>
  );
}
